import React from 'react';
import AppRouter from 'common/AppRouter';
import { getSelectedTabFromUrl, isTeamByLicense } from 'common/utils/utils';
import { Padding, WhiteSection } from 'components/base/layout-components';
import TabList from 'components/TabList';
import { Route, Switch, useHistory } from 'react-router-dom';
import RepositoriesV2 from '../RepositoriesV2';
import GitAuthState from './GitAuthState';
import Services from './Services';
import { useSelector } from 'react-redux';
import { licenseSelector } from 'state/selectors/license';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import MonitoringRulesForm from '../RepositoriesV2/GitIntegration/MonitoringRules/MonitoringRulesForm';
import { isTeamModeHandler } from './git-settings.utils';

const tabs = [
  {
    name: 'Integrations and Repositories',
    type: 'default',
    path: AppRouter.REPOSITORIES.path
  },
  {
    name: 'Services',
    path: AppRouter.GIT_SERVICES.path
  }
];

const GitTabs = ({ modeHandler }) => {
  const history = useHistory();

  const onTabClick = ({ path }) => {
    if (isTeamModeHandler(modeHandler)) {
      modeHandler.setIsSelectedOnly(false);
      history.push(path);
    } else {
      history.push(`${path}?isOrgSettings=true`);
    }
  };

  const selectedTab = getSelectedTabFromUrl(tabs, history);

  return (
    <TabList
      display='inSpacedSection'
      tabs={tabs}
      onTabClick={onTabClick}
      selectedTab={selectedTab ? selectedTab.name : ''}
    />
  );
};

const GitSettings = ({ apiTokens, setApiTokens, modeHandler }) => {
  const history = useHistory();
  const license = useSelector(licenseSelector);
  const { getSettingOrDefinitionValue } = useSettingsService();

  const servicesTabEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.servicesTabEnabled
  });
  const shouldShowServices = servicesTabEnabled && !isTeamByLicense(license);

  return (
    <WhiteSection>
      <Padding t='x-medium'>
        <GitAuthState />
        {shouldShowServices && (
          <Padding l='medium' r='medium'>
            <GitTabs
              apiTokens={apiTokens}
              setApiTokens={setApiTokens}
              modeHandler={modeHandler}
            />
          </Padding>
        )}
        <Switch>
          <Route
            path={AppRouter.REPOSITORIES.path}
            exact
            render={() => (
              <RepositoriesV2
                history={history}
                apiTokens={apiTokens}
                setApiTokens={setApiTokens}
                {...(isTeamModeHandler(modeHandler) && {
                  readonly: true,
                  fetchRepositoriesExtraParams: {
                    state: 'active',
                    ...(modeHandler?.isSelectedOnly && {
                      project_id: modeHandler.team.project_id
                    })
                  },
                  selectionProps: {
                    selectedIds: modeHandler?.selectedReposIds,
                    toggleSelection: modeHandler?.toggleRepoSelection,
                    isSelectedOnly: modeHandler?.isSelectedOnly,
                    setIsSelectedOnly: modeHandler?.setIsSelectedOnly
                  }
                })}
              />
            )}
          />
          <Route
            path={AppRouter.GIT_INTEGRATION_MONITORING_RULES.path}
            exact
            render={() => <MonitoringRulesForm />}
          />
          <Route
            path={AppRouter.GIT_SERVICES.path}
            exact
            render={() => (
              <Services
                {...(isTeamModeHandler(modeHandler) && {
                  readonly: true,
                  selectionProps: {
                    selectedIds: modeHandler?.selectedServicesIds,
                    toggleSelection: modeHandler?.toggleServiceSelection,
                    isSelectedOnly: modeHandler?.isSelectedOnly,
                    setIsSelectedOnly: modeHandler?.setIsSelectedOnly
                  }
                })}
              />
            )}
          />
        </Switch>
      </Padding>
    </WhiteSection>
  );
};

export default GitSettings;
